import axios from 'axios'
import swal from 'sweetalert2'

import {
  isObject,
  isUndefined,
  getParameterOfTheUrl,
} from '../../../plugins/helper'

import is from './is'

const setupSwal = () => {
  return swal.mixin({
    position: 'center',
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Ok',
    cancelButtonText: 'Cancelar',
    showCancelButton: true,
    allowOutsideClick: () => false,
  })
}

axios.interceptors.request.use(request => {
  const object = getParameterOfTheUrl(window.location.search)
  if (!isUndefined(object) && isObject(object)) {
    request.headers.common['Authorization'] = `Bearer ${object.token}`
  }

  const metaToken = is.getNode('meta[name="csrf-token"]')
  if (is.node(metaToken)) {
    const token = is.getUniqueAttribute(metaToken, 'content')
    request.headers.common['X-CSRF-TOKEN'] = token
  }

  return request
})

axios.interceptors.response.use(response => response, error => {
  if (error && error.response) {
    const newSwal = setupSwal()
    const { status, data } = error.response
    if (status) {
      switch (status) {
        case 401:
          newSwal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: 'Inicia sesión nuevamente para continuar.',
          })
          break
        case 403:
          newSwal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: 'No tienes permiso para ingresar aquí.',
          })
          break
        case 422:
          const { errors } = data
          let html = '<table>'
          Object.keys(errors).forEach(error => {
            html = html + '<tr>'
            html = html + `<th>${error}</th>`
            html = html + `<td>${errors[error]}</td>`
            html = html + '</tr>'
          })
          html = html + '</table>'

          newSwal.fire({
            title: 'Error: <u>Por favor verifica los siguientes campos en el formulario.</u>',
            icon: 'error',
            html,
            showCloseButton: true,
            showCancelButton: false,
          })
          break
        default:
          if (status >= 500) {
            newSwal.fire({
              icon: 'error',
              title: 'Oops...',
              text: '¡Algo salió mal! Inténtalo de nuevo.',
            })
          }
          break
      }
    }

    return Promise.reject({
      status,
      ...error,
    })
  }

  return Promise.reject(error)
})
